import { Spacing } from '@persona-id/design-tokens';
import { connect, ConnectedProps } from 'react-redux';
import styled from 'styled-components';

import ToastMessage from 'dashboard/components/Application/ToastMessage';
import Message from 'dashboard/lib/interfaces/Message';
import { RootState } from 'dashboard/redux/store';
import { Z_INDICES } from 'dashboard/styles/variables';

const Toaster = styled('div')`
  position: fixed;
  bottom: ${Spacing[5]};
  right: ${Spacing[5]};
  width: 400px;
  z-index: ${Z_INDICES.toast};
`;

interface NotificationsProps extends PropsFromRedux {
  messages: Message[];
}

const Notifications = (props: NotificationsProps) => {
  return (
    <Toaster data-test='notifications'>
      {props.messages
        .slice()
        .reverse()
        .map((message) => (
          <ToastMessage key={message.id} message={message} />
        ))}
    </Toaster>
  );
};

function mapStateToProps(state: RootState) {
  return {
    messages: state.messages.messages,
  };
}

const connector = connect(mapStateToProps);
type PropsFromRedux = ConnectedProps<typeof connector>;

export default connector(Notifications);
